Billy.Locale.reopen({
    iconUrl: function() {
        return Billy.flagIcon(this.get('icon'))
    }.property('icon')
})
